module.exports = __webpack_public_path__ + "img/zongrenshu.87aa4b79.png";